export default {
    alexa: {
        tcl_assitant: "Enable Skill - TCL Assistant",
        active_code_hint: "Por favor, insira o código de ativação",
        active_code_placeholder: "Código de ativação",

        active_code_message: "Na sua TV TCL, pressione o botão Definições",
        active_code_message_path: " botão no controlo remoto, vá para 'Sistema'> 'Funciona com Alexa',",
        active_code_message_part2: "selecione 'Entrar' ou 'Obter código' para obter o código de ativação.",

        active_code_message_old: "Na sua TV TCL, vamos para ",
        active_code_message_path_old: "Configurações/Sistema/Configurações Alexa/Obter código, ",
        active_code_message_part2_old: "digite o código de ativação abaixo.",
        
        active_code_error_null: "Código não pode ser nulo",
        active_code_error_number: "Por favor insira números",
        active_code_error_bits: "Código deve ter seis números digitais",
        active_code_validate: "Ativar",
        active_code_message_wrong: "Código de ativação está incorreto ou expirou. Adquira novamente.",
        active_code_message_exception: "Verifique sua rede e tente novamente.",
        check_agreements_message: "Você deve concordar com todos os acordos para usar o Assistente TCL.",
        agreements: [
            "Eu concordo que o TCL grave meu comando de voz.",
            "Concordo com ",
            "da TCL.",
        ],
        privacy_policy: "a política de privacidade",

        grant_hint: "Autorize o TCL a operar.",
        grant_message_success: "Você concedeu com sucesso!",
        grant_message_fail: "Falha na concessão, digite novamente o código ativo.",
        grant_allow: "Permitir",

        console_welcome_prompt: "Welcome to TCL Alexa Console",
        empty_message: "",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/br.js
// module id = null
// module chunks = 